const API_BASE_URL = process.env.REACT_APP_WEB_API;
const API_Payment_URL = process.env.REACT_APP_PAYMENT_API;
const API_BASE = process.env.REACT_APP_SOLIDARITY_API_BASE;

export const Reset = async (Token, OldPassword, toast, NewPassword, ConfimrNewPassword, setLoading) => {
    setLoading(true);
    const url = `${API_Payment_URL}Account/Reset`;
    const data = {
      Token: Token,
      OldPassword: OldPassword,
      NewPassword: NewPassword,
      ConfimrNewPassword: ConfimrNewPassword
    };
  
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorDetails = await response.json();
        toast.error(errorDetails.message, {
        style: {
          background: "#ffcccc",
          color: "black",
          fontWeight: "bold",
        },
      });
      setLoading(false);
        return errorDetails;
      }

      const result = await response.json();
      //setIsModalOpen(false);
      toast.success(result.message);
      //fetchPaymentRequests();
      window.location.reload(true);
      setLoading(false);
      return result;
    
  };


export const redirectToEkey = (codeChallenge, isMobile) => {
  const redirectUrl = `${API_BASE}/v1/ekey/redirect-to-ekey?code_challenge=${encodeURIComponent(
    codeChallenge
  )}&isMobile=${isMobile}`;
  window.location.href = redirectUrl;
};

export const exchangeEkeyCode = async (code, verifier) => {
  const url = `${API_BASE}/v1/ekey/ekey-login`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      code: code,
      verifier: verifier,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "eKey login failed");
  }
  const result = await response.json();
  return result;
};
